/**
 * Página de pago pendiente del checkout AR
 * 
 * Cuando el pago está pendiente de aprobación (efectivo, transferencia, etc.)
 */

import { useNavigate } from "react-router-dom";
import { Clock, ExternalLink, Home } from "lucide-react";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";

/** URL de Telegram destino - para cuando el pago sea confirmado */
const TELEGRAM_URL = "https://t.me/+8NXL4D2eaK8xYjUx";

/** Font iOS (San Francisco) */
const FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif';

export default function InvitacionArPending() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-black text-white flex items-center justify-center px-4"
      style={{ fontFamily: FONT_FAMILY }}
    >
      {/* Fondo con gradiente */}
      <div className="fixed inset-0 -z-10 bg-black">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-500 via-amber-500 to-orange-500 opacity-20" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-black/50 to-black" />
      </div>

      <div className="max-w-md w-full text-center space-y-6">
        {/* Icono de pendiente */}
        <div className="relative inline-flex justify-center w-full">
          <div className="absolute inset-0 blur-2xl bg-yellow-500/40 animate-pulse" />
          <div className="relative w-24 h-24 bg-gradient-to-br from-yellow-500 to-amber-500 rounded-full flex items-center justify-center shadow-2xl">
            <Clock className="w-12 h-12 text-white" />
          </div>
        </div>

        {/* Título */}
        <h1 className="text-3xl font-bold bg-gradient-to-r from-yellow-400 to-amber-400 bg-clip-text text-transparent">
          Pago pendiente
        </h1>

        {/* Mensaje */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
          <p className="text-gray-300 text-base leading-relaxed mb-4">
            Tu pago está siendo procesado. Una vez confirmado, recibirás acceso 
            al canal exclusivo de {BRAND_PERSON_NAME}.
          </p>
          <p className="text-gray-400 text-sm">
            Si pagaste en efectivo o por transferencia, el proceso puede demorar 
            hasta 24-48 horas hábiles.
          </p>
        </div>

        {/* Info del canal */}
        <div className="bg-purple-500/10 border border-purple-500/30 rounded-xl p-4">
          <p className="text-purple-300 text-sm mb-2">
            Una vez confirmado tu pago, podrás acceder al canal aquí:
          </p>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-purple-400 hover:text-purple-300 text-sm underline"
          >
            <ExternalLink className="w-4 h-4" />
            Canal de Telegram
          </a>
        </div>

        {/* Botón */}
        <button
          onClick={() => navigate("/")}
          className="w-full py-4 px-6 bg-gradient-to-r from-yellow-500 to-amber-500 rounded-xl font-bold text-white shadow-lg hover:shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-200 flex items-center justify-center gap-2"
        >
          <Home className="w-5 h-5" />
          <span>Volver al inicio</span>
        </button>

        {/* Footer */}
        <p className="text-gray-600 text-xs">
          Te notificaremos cuando tu pago sea confirmado.
        </p>
      </div>
    </div>
  );
}
